<template>
  <div id="SocialList">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">短視頻列表</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">短視頻</li>
              <li class="breadcrumb-item active">短視頻列表</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-banner" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-10">
            <div class="b-filter"></div>
          </div>
          <div class="col-sm-2">
            <button
              type="button"
              class="btn btn-block btn-primary btn-sm"
              data-toggle="modal"
              @click="showQry"
            >
              <i class="nav-icon fas fa-filter fa-sm mr-1"></i> 篩選條件
            </button>
          </div>
          <!-- /.col-12 -->
        </div>
        <div class="row mb-2">
          <div class="col-12">
            <div class="card">
              <div class="demo-input-size row margs"></div>
              <div class="card-body">
                <el-form ref="form" label-width="80px" @submit.native.prevent>
                  <el-row>
                    <el-col
                      :md="{ span: 6, offset: 18 }"
                      :sm="{ span: 8, offset: 16 }"
                      :xs="{ span: 14, offset: 10 }"
                    >
                      <el-form-item label="搜尋:">
                        <el-input
                          placeholder="请输入内容"
                          v-model="qryParams.sgL_Title"
                          clearable
                          @input="handleCurrentChange(1)"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
                <el-table
                  :data="GetList"
                  v-loading="loading"
                  border
                  row-key="id"
                >
                  <el-table-column
                    width="200"
                    label="短視頻標題"
                    prop="sgL_Title"
                  >
                    <template slot-scope="scoped">
                      <div class="b-username">
                        <router-link
                          target="_blank"
                          v-bind:to="{
                            name: `DisplayVideo`,
                            query: {
                              id: scoped.row.id,
                            },
                          }"
                        >
                          {{ scoped.row.sgL_Title }}</router-link
                        >
                      </div>
                      <div>
                        <video
                          controls
                          class="vid"
                          :src="scoped.row.fileUrl"
                        ></video>
                      </div>
                      <div>
                        <span
                          class="b-tag"
                          v-if="!IsNullOrEmpty(scoped.row.sgL_Keyworld)"
                        >
                          <a
                            href="javascript:void(0);"
                            v-for="key in scoped.row.sgL_Keyworld.split(',')"
                            :key="key"
                            v-if="!IsNullOrEmpty(key)"
                          >
                            {{ key }}
                          </a>
                        </span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="上傳者">
                    <template slot-scope="scoped">
                      <span class="b-username">
                        {{ scoped.row.sgL_UsersName }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="上傳日期 / 狀態"
                    prop="sgL_PG_CAddTimerF"
                  >
                    <template slot-scope="scoped">
                      <span class="b-username">
                        {{ scoped.row.sgL_PG_CAddTimerF }}
                      </span>
                      <span
                        v-show="
                          scoped.row.sgL_IsShow != null && scoped.row.sgL_IsShow
                        "
                        class="b-subtext b-public"
                        >公開</span
                      >
                      <span
                        v-show="
                          scoped.row.sgL_IsShow != null &&
                          !scoped.row.sgL_IsShow
                        "
                        class="b-subtext b-unlisted"
                        >非公開</span
                      >
                      <span
                        v-show="scoped.row.sgL_IsShow == null"
                        class="b-subtext b-private"
                        >私人</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="容量" prop="sgL_Size">
                    <template slot-scope="scoped">
                      <span>
                        {{ (scoped.row.sgL_Size / 1024 / 1024).toFixed(2) }}M
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="片長(秒)"
                    prop="sgL_Length"
                  ></el-table-column>
                  <el-table-column
                    label="瀏覽量"
                    prop="sgL_PG_CTotalView"
                  ></el-table-column>
                  <el-table-column
                    label="讚好"
                    prop="sgL_PG_CTotalLike"
                  ></el-table-column>
                  <el-table-column
                    label="留言"
                    prop="sgL_PG_CTotalMesg"
                  ></el-table-column>
                  <el-table-column
                    label="收藏"
                    prop="sgL_PG_CTotalFavorite"
                  ></el-table-column>
                  <el-table-column
                    label="分享"
                    prop="sgL_PG_CTotalShare"
                  ></el-table-column>
                  <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                      <span
                        v-if="$store.getters.getAdminUser.userId == 1"
                        class="b-operate-btn b-edit"
                        ><a
                          href="javascript:void(0);"
                          @click="Retry(scope.row)"
                        >
                          重試剪裁
                        </a></span
                      >
                      <span class="b-operate-btn b-edit"
                        ><a
                          href="javascript:void(0);"
                          @click="pub(scope.row, 1)"
                        >
                          公開
                        </a></span
                      >
                      <span class="b-operate-btn b-edit"
                        ><a
                          href="javascript:void(0);"
                          @click="pub(scope.row, 0)"
                        >
                          不公開
                        </a></span
                      >
                      <span class="b-operate-btn b-edit"
                        ><a
                          href="javascript:void(0);"
                          @click="pub(scope.row, null)"
                        >
                          隱藏
                        </a></span
                      >
                      <span class="b-operate-btn b-edit"
                        ><a href="javascript:void(0);" @click="del(scope.row)">
                          刪除
                        </a></span
                      >
                      <span v-if="scope.row.sgL_GroupId == null" class="b-operate-btn b-edit"
                        ><a href="javascript:void(0);" @click="SetFeatured(scope.row)">
                        <!-- 設為精選 -->
                          {{ scope.row.updateSelected ?'移除精選':'設為精選'}}
                        </a></span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- /.card-body -->
            </div>
            <div class="row">
              <div class="col-lg-4 offset-lg-7">
                <!--  引用分页组件 -->
                <pagination
                  v-if="pageParams.pageshow"
                  :currentPage="pageParams.currentPage"
                  :total="pageParams.total"
                  :limit="pageParams.limit"
                  :small="true"
                  @handleCurrentChange="handleCurrentChange"
                  @handleSizeChange="handleSizeChange"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>

    <div
      class="modal fade"
      id="modal-album--filter"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">篩選條件</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>名稱</label>
              <div class="input-group mb-3">
                <input class="form-control" v-model="qryParams.sgL_Title" />
              </div>
            </div>
            <div class="form-group mb-3">
              <label>上傳者</label>
              <div class="input-group mb-3">
                <input class="form-control" v-model="qryParams.sgL_UsersName" />
              </div>
            </div>
            <div class="form-group mb-3">
              <label>公開狀態</label>
              <div class="form-group">
                <select
                  class="
                    form-control
                    custom-select
                    select2-no-search select2-hidden-accessible
                  "
                  data-select2-id="1"
                  tabindex="-1"
                  aria-hidden="true"
                  v-model="qryParams.sgL_IsShow"
                >
                  <option value="">全部</option>
                  <option value="true">公開</option>
                  <option value="false">不公開</option>
                </select>
              </div>
            </div>
            <div class="form-group mb-3">
              <label>上傳日期介乎</label>
              <div class="input-group">
                <el-date-picker
                  v-model="qryParams.Date"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="開始日期"
                  end-placeholder="結束日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </div>
            </div>
            <div class="form-group mb-3">
              <label>包含關鍵字</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control float-right"
                  v-model="qryParams.sgL_Keyworld"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              取消
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-toggle="modal"
              data-dismiss="modal"
              @click="handleCurrentChange(1)"
            >
              篩選
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import { Message } from "element-ui";
import pagination from "../common/Page";
export default {
  data() {
    return {
      qryParams: {
        sgL_Title: "",
        sgL_UsersName: "",
        sgL_IsShow: "",
        Date: null,
        sgL_Keyworld: "",
      },
      SocialList: [],
      pageParams: {
        pageshow: true,
        currentPage: 1, //當前頁
        total: 0, //總條數
        limit: 5, //顯示條數
      },
      loading: false,
    };
  },
  created() {
    this.handleCurrentChange(1);
  },
  watch: {},
  methods: {
    Retry(item) {
      let arr = [];
      arr.push(item.id);
      let params = {
        sgL_MoiveCommunityId: arr,
      };
      this.$api.social.AdminVideoReTry(params).then((res) => {
        if (res.data.success) {
          Message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
        } else {
          Message({
            type: "error",
            message: res.data.error.message,
          });
        }
      });
    },
    async SetFeatured(item){
      const params = {
        id:item.id
      };
      const { data: result } = await this.$api.social.AdminUpdateSelected(params);
      if (!result.success) {
        result.error.code !== 500 && this.$message.error(result.error.message);
        return;
      }
      this.$message.success('操作成功');
      this.handleCurrentChange(1);
    },
    clearQry() {
      this.qryParams.sgL_Title = "";
      this.qryParams.sgL_UsersName = "";
      this.qryParams.sgL_IsShow = "";
      this.qryParams.Date = null;
      this.qryParams.sgL_Keyworld = "";
    },
    showQry() {
      this.clearQry();
      $("#modal-album--filter").modal("show");
    },
    pub(item, val) {
      let params = {
        id: item.id,
        sgL_IsShow: val,
      };
      this.$api.social.AdminUpdate(params).then((res) => {
        if (res.data.success) {
          Message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
          this.handleCurrentChange(1);
        } else {
          Message({
            type: "error",
            message: res.data.error.message,
          });
        }
      });
    },
    del(item) {
      let msg = `確認刪除短視頻
      「${item.sgL_Title}」？
      短視頻一旦刪除，將無法復原。`;
      this.$confirm(msg, "提示", {
        confirmButtonText: "是，刪除",
        cancelButtonText: "取消",
      }).then(() => {
        let params = {
          Id: item.id,
        };
        this.loading = true;
        this.$api.social.AdminDelete(params).then((res) => {
          if (res.data.success) {
            Message({
              type: "success",
              message: this.$t('message.operatesuccessfully'),
            });
            this.handleCurrentChange(1);
          }
        });
      });
    },
    Look(item) {
      this.$router.push({ name: "feed", query: { id: item.id } });
    },
    getSocialList() {
      let params = {
        SGL_Title: this.qryParams.sgL_Title,
        SGL_UsersName: this.qryParams.sgL_UsersName,
        SGL_IsShow: this.qryParams.sgL_IsShow,
        SGL_Keyworld: this.qryParams.sgL_Keyworld,
        SGL_Type: 0,
        IsLogin: true,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
      };
      if (this.qryParams.Date) {
        params.SGL_CreateTimeArry = this.qryParams.Date;
      }
      if (this.IsNullOrEmpty(params.SGL_IsShow)) {
        params.SGL_IsShow = null;
      } else {
        params.SGL_IsShow = params.SGL_IsShow == "true";
      }
      this.loading = true;
      this.$api.social
        .AdminMoiveCommunity(params)
        .then((res) => {
          if (res.data.success) {
            this.SocialList = res.data.result.items;
            this.pageParams.total = res.data.result.totalCount;
          } else {
            Message({
              type: "error",
              message: res.data.error.message,
            });
          }
        })
        .catch()
        .then((obj) => {
          this.loading = false;
        });
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getSocialList();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getSocialList();
    },
  },
  components: {
    pagination,
  },
  computed: {
    GetList() {
      return this.SocialList;
    },
  },
};
</script>

<style scoped>
.filter .current {
  background-color: #2e3e4a;
  color: #fff !important;
}
.vid {
  width: 100%;
  height: 100%;
  max-height: 200px;
  object-fit: fill;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminSocial/VideoList.vue